import Immutable from 'seamless-immutable';

export default () =>
  Immutable({
    cropSources: {
      data: { files: [] },
      src: '',
    },
    crop: {
      // Default crop is 100%
      x: 0,
      y: 0,
      width: 100,
      height: 100,
    },
  });
